import { getCookie } from './getCookie'

export function deleteCookie ( name: string ) {
  const encoded: string | undefined = getCookie(name)
  if( encoded ) {
    document.cookie = `${name}=${encoded}; expires=Thu, 01 Jan 1970 00:00:01 GMT`
  }
}
